<div id="wrapper">
    <!-- <app-navbar></app-navbar> -->
    <div class="navbar-custom">
        <div class="container-fluid">
            <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
                <li>
                    <button
                        class="button-menu-mobile waves-effect waves-light"
                        (click)="toggleSidebar()"
                    >
                        <i class="ri-menu-line"></i>
                    </button>
                </li>
                <li class="breadcrumb">
                    <span class="breadcrumb-item">
                        <a href="javascript:void(0)">PayEXAP</a>
                    </span>
                    <span class="px-2"
                        ><i class="ri-arrow-right-s-line"></i
                    ></span>
                    <span class="breadcrumb-item" aria-current="page">
                        <a routerLink="/invoices">Invoices</a>
                    </span>
                    <span class="px-2"
                        ><i class="ri-arrow-right-s-line"></i
                    ></span>
                    <span class="breadcrumb-item" aria-current="page">
                        <a routerLink="/saved-invoices">Saved Invoices</a>
                    </span>
                    <span class="px-2"
                        ><i class="ri-arrow-right-s-line"></i
                    ></span>
                    <span class="breadcrumb-item" aria-current="page">
                        <a href="javascript:void(0)">Invoice Preview</a>
                    </span>
                </li>
            </ul>
            <ul class="navbar-nav list-unstyled topnav-menu float-end">
                <li class="nav-item dropdown nav-user">
                    <span
                        class="pro-user-name ms-1 dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {{ displayName }}
                    </span>
                    <ul class="dropdown-menu">
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/vendor-profile"
                            >
                                <i class="ri-user-3-line"></i>
                                <span class="ml-2">Vendor Profile</span>
                            </a>
                        </li>
                        <li>
                            <a
                                class="dropdown-item"
                                routerLink="/change-password"
                            >
                                <i class="ri-lock-2-line"></i>
                                <span class="ml-2">Change Password</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item">
                                <i class="ri-logout-box-line"></i>
                                <span class="ml-2"> Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content">
            <div class="dashboard-pane">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="pane-header">
                                    <h4 class="my-3">Submit Invoice</h4>
                                </div>
                                <form
                                    [formGroup]="extractedInvoice"
                                    (ngSubmit)="onSubmit()"
                                >
                                    <div class="row">
                                        <div class="col-7">
                                            <div class="form-wrapper pb-5">
                                                <div class="form-header pb-4">
                                                    <h6 class="mb-3">
                                                        Invoice Header Details
                                                        Extracted
                                                    </h6>
                                                    <p>
                                                        Review invoice data
                                                        extracted and submit
                                                    </p>
                                                    <div
                                                        *ngIf="hasError"
                                                        class="alert alert-danger"
                                                        role="alert"
                                                    >
                                                        <ng-container
                                                            *ngIf="
                                                                responseData.raw ===
                                                                undefined
                                                            "
                                                        >
                                                            <p>
                                                                {{
                                                                    responseData.message
                                                                }}
                                                            </p>
                                                        </ng-container>

                                                        <ng-container
                                                            *ngIf="
                                                                responseData.raw !==
                                                                undefined
                                                            "
                                                        >
                                                            <ul
                                                                *ngFor="
                                                                    let error of responseData
                                                                        .raw
                                                                        .errors
                                                                "
                                                            >
                                                                <li>
                                                                    {{ error }}
                                                                </li>
                                                            </ul>
                                                        </ng-container>
                                                    </div>

                                                    <div
                                                        *ngIf="fileSizeError"
                                                        class="alert alert-danger"
                                                        role="alert"
                                                    >
                                                        <p>
                                                            The file size is not
                                                            supported. File must
                                                            not exceed 5mb.
                                                        </p>
                                                    </div>
                                                    <div
                                                        *ngIf="fileTypeError"
                                                        class="alert alert-danger"
                                                        role="alert"
                                                    >
                                                        <p>
                                                            The file type is
                                                            invalid. File must
                                                            be a pdf
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="invoice-data">
                                                    <ng-container
                                                        *ngIf="isUpdatedData"
                                                    >
                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    for="inputPassword6"
                                                                    class="col-form-label"
                                                                    >GSTIN</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.gstin
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >IRN</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.irn
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >PO
                                                                    No.</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails
                                                                            .items[0]
                                                                            .poNo
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >Invoice
                                                                    No.</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.invoice_number
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >Document
                                                                    Date</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.invoice_date
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >Document
                                                                    Amount</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.invoice_amount
                                                                            | number
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="!isUpdatedData"
                                                    >
                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    for="inputPassword6"
                                                                    class="col-form-label"
                                                                    >GSTIN</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.gstin
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >IRN</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.irn
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >PO
                                                                    No.</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails
                                                                            .items[0]
                                                                            .poNo
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >Invoice
                                                                    No.</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.invoice_number
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >Document
                                                                    Date</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.invoice_date
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="row g-3 align-items-center my-2"
                                                        >
                                                            <div class="col-3">
                                                                <label
                                                                    class="col-form-label"
                                                                    >Document
                                                                    Amount</label
                                                                >
                                                            </div>
                                                            <div class="col-9">
                                                                <p>
                                                                    {{
                                                                        invoiceDetails.invoice_amount
                                                                            | number
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-5">
                                            <div class="form-header pb-4">
                                                <div class="row">
                                                    <div class="col-7">
                                                        <h6 class="mb-3">
                                                            Invoice Preview
                                                        </h6>
                                                    </div>
                                                    <div class="col-5">
                                                        <div
                                                            class="icon-wrapper re-upload"
                                                        >
                                                            <label
                                                                for="invoice-resubmit"
                                                                class="change-invoice"
                                                            >
                                                                <i
                                                                    class="ri-upload-cloud-2-line"
                                                                ></i>
                                                                Change Invoice
                                                            </label>
                                                            <input
                                                                type="file"
                                                                id="invoice-resubmit"
                                                                class="form-control"
                                                                #fileInput
                                                                (change)="
                                                                    reUploadInvoice(
                                                                        $any(
                                                                            $event
                                                                        ).target
                                                                            .files
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="preview-pane">
                                                    <ng-container
                                                        *ngIf="!isInvoiceChange"
                                                    >
                                                        <ngx-extended-pdf-viewer
                                                            [src]="
                                                                this
                                                                    .invoiceDetails
                                                                    .file_link
                                                            "
                                                            [height]="'380px'"
                                                            [useBrowserLocale]="
                                                                true
                                                            "
                                                        >
                                                        </ngx-extended-pdf-viewer>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="isInvoiceChange"
                                                    >
                                                        <ngx-extended-pdf-viewer
                                                            [src]="pdfSrc"
                                                            [height]="'380px'"
                                                            [useBrowserLocale]="
                                                                true
                                                            "
                                                        >
                                                        </ngx-extended-pdf-viewer>
                                                    </ng-container>
                                                </div>

                                                <div
                                                    class="supporting-docs-pane"
                                                >
                                                    <h6>
                                                        Supporting Documents
                                                    </h6>

                                                    <div class="drop-pane">
                                                        <div class="row">
                                                            <div
                                                                class="col-md-12 text-center"
                                                            >
                                                                <div
                                                                    class="fileupload documents"
                                                                    appDragNDrop
                                                                    (click)="
                                                                        supportingFiles.click()
                                                                    "
                                                                    (fileDropped)="
                                                                        selectDocuments(
                                                                            $event
                                                                        )
                                                                    "
                                                                >
                                                                    <span
                                                                        class="files-wrapper"
                                                                        ><i
                                                                            class="ri-file-pdf-line"
                                                                        ></i>
                                                                    </span>
                                                                    <span
                                                                        class="ddinfo"
                                                                        >Drag
                                                                        and Drop
                                                                        File(s)
                                                                        Here</span
                                                                    >
                                                                    <p
                                                                        class="ddsperator mt-3"
                                                                    >
                                                                        OR
                                                                    </p>
                                                                    <label
                                                                        for="file-upload"
                                                                        class="custom-file-upload"
                                                                    >
                                                                        <i
                                                                            class="ri-upload-cloud-2-line"
                                                                        ></i>
                                                                        Choose
                                                                        File(s)
                                                                        to
                                                                        Upload
                                                                    </label>
                                                                    <input
                                                                        id="supportingFiles"
                                                                        class="form-control"
                                                                        type="file"
                                                                        multiple
                                                                        formControlName="supportingFiles"
                                                                        #supportingFiles
                                                                        (change)="
                                                                            selectDocuments(
                                                                                $any(
                                                                                    $event
                                                                                )
                                                                                    .target
                                                                                    .files
                                                                            )
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-md-12"
                                                            >
                                                                <div
                                                                    *ngIf="
                                                                        typeError
                                                                    "
                                                                    class="alert alert-danger session-text text-center"
                                                                    role="alert"
                                                                >
                                                                    <span
                                                                        >The
                                                                        file
                                                                        type is
                                                                        invalid.
                                                                        Files
                                                                        must be
                                                                        pdfs</span
                                                                    >
                                                                </div>
                                                                <div
                                                                    *ngIf="
                                                                        sizeError
                                                                    "
                                                                    class="alert alert-danger session-text text-center"
                                                                    role="alert"
                                                                >
                                                                    <span
                                                                        >The
                                                                        file
                                                                        size is
                                                                        not
                                                                        supported.
                                                                        A single
                                                                        File
                                                                        must not
                                                                        exceed
                                                                        5mb.
                                                                    </span>
                                                                </div>
                                                                <div
                                                                    class="document-pane"
                                                                    *ngIf="
                                                                        supportingDocuments.length !==
                                                                        0
                                                                    "
                                                                >
                                                                    <p
                                                                        class="align-right mt-3 mb-3"
                                                                    >
                                                                        Files
                                                                        Selected:
                                                                        {{
                                                                            supportingDocuments.length
                                                                        }}
                                                                    </p>
                                                                    <div
                                                                        *ngFor="
                                                                            let file of supportingDocuments;
                                                                            let i = index
                                                                        "
                                                                        class="file-pane"
                                                                    >
                                                                        <div
                                                                            class="row"
                                                                        >
                                                                            <div
                                                                                class="col-md-10"
                                                                            >
                                                                                <span>
                                                                                    {{
                                                                                        file.name
                                                                                    }}
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            >
                                                                                <span
                                                                                    class="delete"
                                                                                    (click)="
                                                                                        deleteFile(
                                                                                            i
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <i
                                                                                        class="ri-close-line"
                                                                                    ></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-5 mb-3">
                                            <div class="row">
                                                <div class="col-7">
                                                    <div
                                                        class="form-check mt-2"
                                                    >
                                                        <div
                                                            class="check-pane"
                                                            *ngFor="
                                                                let state of agreed
                                                            "
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                id="flexCheckDefault"
                                                                formControlName="terms_agreed"
                                                                [value]="
                                                                    state.status
                                                                "
                                                                (change)="
                                                                    onCheckboxChange(
                                                                        $event
                                                                    )
                                                                "
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                (click)="
                                                                    open(
                                                                        validateModal
                                                                    )
                                                                "
                                                            >
                                                                Accept
                                                                <span
                                                                    >Terms and
                                                                    Conditions</span
                                                                >
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-5">
                                                    <div
                                                        class="btn-pane float-end"
                                                    >
                                                        <span
                                                            (click)="
                                                                saveUploadData()
                                                            "
                                                            class="btn save preview"
                                                        >
                                                            Save and Continue
                                                            Later
                                                        </span>
                                                        <button
                                                            [disabled]="
                                                                extractedInvoice.invalid
                                                            "
                                                            class="btn submit preview"
                                                        >
                                                            Submit Invoice
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="loader-wrapper" *ngIf="loading">
                            <ng-container *ngIf="invoiceChanged">
                                <div class="loader-content loading">
                                    <div class="loader-text">
                                        <span class="ml-2"
                                            >Changing Invoice File</span
                                        >
                                        <p class="text-white my-4">
                                            Please wait a few minutes
                                        </p>
                                    </div>
                                    <div class="loader-cta my-4">
                                        <div class="placeholder-wave">
                                            <span
                                                class="placeholder col-12 placeholder-sm"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="saving && !uploadInvoice">
                                <div class="loader-content loading">
                                    <div class="loader-text">
                                        <span class="ml-2">Saving Invoice</span>
                                        <p class="text-white my-4">
                                            Please wait a few minutes
                                        </p>
                                    </div>
                                    <div class="loader-cta my-4">
                                        <div class="placeholder-wave">
                                            <span
                                                class="placeholder col-12 placeholder-sm"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="uploadSuccessful">
                                <div class="loader-content success">
                                    <div class="loader-text">
                                        <i class="ri-checkbox-circle-fill"></i
                                        ><span class="ml-2"
                                            >Invoice Submitted</span
                                        >
                                    </div>
                                    <div class="loader-cta my-4">
                                        <button
                                            class="btn btn-success"
                                            (click)="closeSuccessDialog()"
                                        >
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="invoiceSaved && !uploadSuccessful"
                            >
                                <div class="loader-content">
                                    <div class="loader-text text-white">
                                        <p>
                                            Invoice save successfully. All
                                            temporarily saved invoices will be
                                            deleted after 1 calender month
                                        </p>
                                    </div>
                                    <div class="loader-cta my-4">
                                        <button
                                            class="btn btn-success"
                                            (click)="viewSavedInvoices()"
                                        >
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="uploadInvoice">
                                <div class="loader-content loading">
                                    <div class="loader-text">
                                        <span class="ml-2"
                                            >Submitting Invoice</span
                                        >
                                        <p class="text-white my-4">
                                            Please wait a few minutes
                                        </p>
                                    </div>
                                    <div class="loader-cta my-4">
                                        <div class="placeholder-wave">
                                            <span
                                                class="placeholder col-12 placeholder-sm"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #validateModal let-modal>
    <div class="modal-header pt-2">
        <h4 class="">Declaration</h4>
    </div>

    <div class="modal-body">
        <ul>
            <li class="mb-3">
                This is a legitimate tax invoice with an IRN number.
            </li>
            <li class="mb-3">
                We provide consent to JSW to validate the IRN number.
            </li>
            <li class="my-3">
                The first 3 pages of this document attached is the Tax invoice.
            </li>
            <li class="my-3">
                We have attached all the supporting documents as requested by
                JSW.
            </li>
            <li class="my-3">
                We agree that JSW can send the invoice back in case of
                validation failures.
            </li>
        </ul>
    </div>

    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-white"
            (click)="modal.dismiss('Cross click')"
        >
            Close
        </button>
    </div>
</ng-template>
